module.exports = __webpack_public_path__ + "static/media/2.acaa0712.jpg";